module.exports = __webpack_public_path__ + "static/media/02-2-galeria-03-concierge-mobile@2x.e2f91b00.jpg";